import { Link } from "react-router-dom";
import { HelpCircle, Minus, Plus } from "../../../assets/icons";
import Tooltip from "../tooltip-1";

type AccordionProps = {
  title: string;
  content: JSX.Element;
  isOpen: boolean;
  onToggle: () => void;
  tooltipText?: string;
  link?: string;
  text?: string;
  id?: string;
};

const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  isOpen,
  onToggle,
  tooltipText,
  link,
  text,
  id
}) => {
  return (
    <div className='rounded-lg border border-darkcolor-400' id={id}>
      <div
        className={`flex items-center justify-between cursor-pointer focus:outline-none py-3 px-4 bg-darkcolor-600 select-none ${!isOpen ? "rounded-lg" : "rounded-t-lg border-b border-darkcolor-400"
          }`}
        onClick={onToggle}
      >
        <div className='flex items-center gap-4'>
          <span className='p-2 rounded-md border border-primary-700 bg-primary-600 shadow-sm'>
            {isOpen ? <Minus size={20} /> : <Plus size={20} />}
          </span>
          <span className='font-semibold text-[16px] text-primary-400'>
            {title}
          </span>
        </div>
        <div className="flex items-center">
          {text && (
            <label className='text-[14px] text-white font-semibold mr-2'>{text}</label>
          )}
          {tooltipText && (
            <Tooltip content={tooltipText}>
              <a href={link ?? ""} target='_blank' rel='noopener noreferrer' onClick={(e) => e.stopPropagation()}>
                <HelpCircle className='cursor-pointer' />
              </a>
            </Tooltip>
          )}
        </div>
      </div>
      {isOpen && <div className=''>{content}</div>}
    </div>
  );
};

export default Accordion;
